import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function templatePacks() {
    return {
        index,
        create,
        update,
        getDetail,
        deletePack
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            agency: null,
            packType: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`template-pack/search${params}`);
    }

    function getDetail(id) {
        return axiosInstance.get(`template-pack/get?id=${id}`);
    }

    function create(payload) {
        return axiosInstance.post(
            `template-pack/create`,
            JSON.stringify(payload)
        );
    }

    function update(payload) {
        return axiosInstance.patch(
            `template-pack/update`,
            JSON.stringify(payload)
        );
    }

    function deletePack(payload) {
        return axiosInstance.delete(`template-pack/delete`, {
            data: JSON.stringify(payload)
        });
    }
}
